import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import styles from './AuthDialog.scss';

import {ButtonLink, ScrollableDialog, Dialog} from 'components/controls';
import RegistrationFormContainer from './Register/RegistrationFormContainer';
import SelectRoleDialog from 'components/Auth/Register/SelectRoleDialog';
import Button from 'components/controls/buttons/Button';


export default class RegisterDialog extends PureComponent {
    static propTypes = {
        onClose: PropTypes.func.isRequired,
        onLoginLinkClick: PropTypes.func.isRequired,
        onLoginUserFromRegister: PropTypes.func.isRequired,
        onLogout: PropTypes.func
    };

    state = {
        registrationAs: null,
        step: 0,
    };

    scrollbarsRef = null;

    setScrollbarsRef = element => {
        this.scrollbarsRef = element;
    }

    handleScrollTo = (to) => {
        this.scrollbarsRef.scrollTop(to);
    }

    handleNextStep = (role) => {
        this.setState({
            registrationAs: role,
        });
    }

    handleToPrev = () => {
        const {step} = this.state;

        if (step > 0) {
            this.setState({
                step: step - 1,
            })
            return;
        }

        this.setState({
            registrationAs: null,
        });
    }

    handleChangeStep = (step) => {
        this.setState({
            step,
        });
    }

    handleGoToProfile = () => {
        const {onLoginUserFromRegister, registration} = this.props;
        onLoginUserFromRegister(registration);
        window.location = '/profile';
    }

    handleCloseSuccessStep = () => {
        this.props.onLogout();
        this.props.onClose();
    }

    renderDoctorSuccess = () => {
        return (
            <Dialog
                onClose={this.handleCloseSuccessStep}
                containerClassName={styles.body}
                contentClassName={styles.scrollableDialogContent}
                dialogClassName={styles.dialog}
                title={(
                    <div className={styles.header}>
                        <div className={styles.smallLogo} />
                        <div className={styles.infoText}>{loc('thank-you')}</div>
                    </div>
                )}
            >
                <div className={styles.success}>
                    <p>{loc('send-approve-email')}<br />
                        {loc('fill-profile-while-review')}</p>

                    <Button
                        label={loc('go-to-profile')}
                        className={styles.submitButton}
                        onClick={this.handleGoToProfile}
                    />
                </div>
            </Dialog>
        );
    }

    renderPatientSuccess = () => {
        const {onClose} = this.props;
        return (
            <Dialog
                onClose={onClose}
                containerClassName={styles.body}
                contentClassName={styles.scrollableDialogContent}
                dialogClassName={styles.dialog}
                title={(
                    <div className={styles.header}>
                        <div className={styles.smallLogo} />
                        <div className={styles.infoText}>{loc('thank-you')}</div>
                    </div>
                )}
            >
                <div className={styles.success}>
                    <p>{loc('successfully-registered')}<br />
                        {loc('check-email-and-confirm')}</p>

                    <Button label={loc('ok-label')}
                        className={styles.submitButton}
                        onClick={onClose}
                    />
                </div>
            </Dialog>
        );
    }

    render() {
        const {registrationAs, step} = this.state;
        const {registration, onClose, onLoginLinkClick} = this.props;

        if (registration && registrationAs === 'doctor')
            return this.renderDoctorSuccess();

        if (registration && registrationAs === 'patient')
            return this.renderPatientSuccess();

        if (!registrationAs) {
            return (
                <SelectRoleDialog
                    onLoginLinkClick={onLoginLinkClick}
                    onClose={onClose}
                    onNext={this.handleNextStep}
                />
            );
        }

        return (
            <ScrollableDialog
                scrollbarRef={this.setScrollbarsRef}
                title={this.renderTitle()}
                containerClassName={styles.body}
                contentClassName={styles.scrollableDialogContent}
                onClose={onClose}
                isLong
            >
                <RegistrationFormContainer
                    type={registrationAs}
                    step={step}
                    onChangeStep={this.handleChangeStep}
                    onClose={onClose}
                    onScroll={this.handleScrollTo}
                    onLoginLinkClick={onLoginLinkClick}
                />
            </ScrollableDialog>
        );
    }

    renderTitle() {
        const {registrationAs, step} = this.state;
        const title = registrationAs === 'doctor'
            ? loc('sign-up-doctor-title')
            : loc('sign-up-patient-title');
        return (
            <div className={styles.header}>
                {registrationAs &&
                    <ButtonLink className={styles.backButton} onClick={this.handleToPrev} />}
                {title}
                {registrationAs === 'doctor' && (
                    <div className={styles.stepContainer}>
                        {`Step ${step + 1}/2`}
                    </div>
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Auth/RegisterDialog.js